import { jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, useCallback, useEffect, useRef, } from 'react';
import classNames from 'classnames';
import styles from './Breadcrumbs.module.scss';
import { BreadcrumbsItem } from './BreadcrumbsItem';
const Breadcrumbs = ({ children, className, separator = '/' }) => {
    const breadcrumbsRef = useRef();
    const scrollToCurrentTitle = () => {
        const elm = breadcrumbsRef.current;
        if (elm) {
            elm.scrollLeft = elm.scrollWidth;
        }
    };
    useEffect(() => {
        window.addEventListener('resize', scrollToCurrentTitle);
        return () => {
            window.removeEventListener('resize', scrollToCurrentTitle);
        };
    }, []);
    const refCallback = useCallback((node) => {
        if (node !== null) {
            breadcrumbsRef.current = node;
            scrollToCurrentTitle();
        }
    }, []);
    return (_jsx("nav", { className: className, "aria-label": "Breadcrumbs", children: _jsx("ol", { 
            // a default padding for "ol" is set in koopa - we need to set it to 0
            className: classNames('d-flex align-items-center pl-0', styles.breadcrumbs), ref: refCallback, children: Children.map(children, child => {
                const props = child.props;
                return cloneElement(child, {
                    ...props,
                    separator,
                });
            }) }) }));
};
Breadcrumbs.Item = BreadcrumbsItem;
export { Breadcrumbs };
